module.exports = __webpack_public_path__ + "img/refuse.a7825843.png";